import React from "react";
import { useTranslation } from "react-i18next";

import {
  HvGlobalActions,
  HvTypography,
  HvGrid,
} from "@hitachivantara/uikit-react-core";

import clsx from "clsx";
import useStyles from "./styles";
import TypeContent from "./TypeContent";

export interface CameraTypeProps {
  type: string;
  mode: string;
}

const CameraType: React.FC<CameraTypeProps> = (props) => {
  const { t } = useTranslation("cameraAddEdit");
  const classes = useStyles();

  return (
    <HvGrid container className={clsx(classes.root)}>
      <HvGrid xs={12} sm={12} item>
        <HvGlobalActions title={t("cameraType.title")} variant="section" />
        <HvTypography variant="normalText">
          {t("cameraType.description")}
        </HvTypography>
      </HvGrid>
      <TypeContent type={props.type} mode={props.mode} />
    </HvGrid>
  );
};

export default CameraType;
